type ThemeBaseColor = 'green' | 'blue' | 'red' | 'orange';
type ThemeColorValue = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9';
type ThemeColor = `${ThemeBaseColor}.${ThemeColorValue}`;

// Base and UI colors
export const COLORS = {
  darkBlue: '#0F3161',
  darkGreen: '#036E3A',
  greyBlue: '#4e5c6a',
  lightBlue: '#8B97AF',
  lightGreen: '#92FE88',
  red: '#D82A3B',
  white: '#FFFFFF',
  black: '#000000',
};

// Theme colors with dot notation
const MANTINE_COLORS: Record<string, ThemeColor> = {
  darkGreen: 'green.9',
  darkRed: 'red.8',
  mediumOrange: 'orange.7',
  lightBlue: 'blue.4',
};

export const UI_COLORS = {
  warning: MANTINE_COLORS.mediumOrange,
  error: MANTINE_COLORS.darkRed,
  success: MANTINE_COLORS.darkGreen,
  // Misleading, but the theme's blue maps to this even though it is something darker like #003166
  darkBlue: 'blue',
};

export const SELECTED_MARKER_RED = COLORS.red;

export const OVERLAY_GREY = '#C4C4C4';
export const BORDER_GREY = '#404040';
export const RESTRICTED_RED = '#E88484';
export const MAP_HEADER_GRAY = '#8897B1';
export const LIGHT_GREY_BG = '#f0f0f0';

// Draw tools
export const DRAW_LIGHT_BLUE = '#3bb2d0';
export const DRAW_DARK_BLUE = '#0e6996';
export const DRAW_ORANGE = '#fbb03b';
export const DRAW_DARK_GREY = '#404040';

// App-or-concept-specific
export const RISK_FILL_COLORS = {
  HIGH_RISK: '#E68080',
  MODERATE_RISK: '#FFBD80',
  LOW_RISK: '#80DBA3',
  NOT_DETECTED: '#C4C4C4',
};

export const PH_COLORS = {
  high: '#1d3564',
  mid: '#8a5796',
  low: '#f4bd4f',
};

export const CROP_PLAN_YELLOW = '#FFEC99';
export const NO_RISK_FILL = '#00B84A';
export const NOT_ANALYZED_FILL = '#000000';
export const NO_DATA_FILL = '#dddddd';

export const PRESCRIPTION_COLORS: [number, string][] = [
  [0.1, '#89b6ff'],
  [0.2, '#76a9ff'],
  [0.3, '#629dff'],
  [0.4, '#4e91ff'],
  [0.5, '#3b85ff'],
  [0.6, '#2778ff'],
  [0.7, '#146cff'],
  [0.8, '#0060ff'],
  [0.9, '#0059eb'],
  [1, '#0051d8'],
];
